module.exports = __webpack_public_path__ + "static/r8-9f54dd9038dbcefa97a4eea22a758f84.jpg";